/**
 * @generated SignedSource<<98f17c2f802ffc2b779e63bb5a3c39c4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LinkRelationshipTypeCell_fieldRef$data = {
  readonly id: string;
  readonly isEditableInIssueView?: boolean | null | undefined;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef">;
  readonly " $fragmentType": "LinkRelationshipTypeCell_fieldRef";
};
export type LinkRelationshipTypeCell_fieldRef$key = {
  readonly " $data"?: LinkRelationshipTypeCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkRelationshipTypeCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isEditableSyncLoaded"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "LinkRelationshipTypeCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isEditableSyncLoaded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditableInIssueView"
        }
      ]
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef"
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "6e86b25020acd81a9ac5426b8f69e24b";

export default node;
